import React, {useState} from 'react';
import {Collapse} from 'reactstrap';
import moment from 'moment-timezone';

const StatusItem = ({title, mainStatus, item}) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    // const handleName = (name) => {
    //     switch(name) {
    //         case 'google':
    //             return 'Google Alert';
    //         case 'email_publication':
    //             return 'Email to RSS';
    //         case 'internal':
    //             return 'Internal Alert';
    //         case 'internal_group':
    //             return 'Internal Group';
    //         case 'rss':
    //             return 'RSS Alert';
    //         case 'newsletter':
    //             return 'Newsletter';
    //         case 'courtlink':
    //             return 'CourtLink';
    //         default:
    //             return null;
    //     }
    // }

    return (
        <div className="status__category animated fadeIn">
            <div className="status__category-header" onClick={() => toggle('test')}>
                <div className="status__category-header-inner">
                    <i className={'fas ' + (isOpen ? 'fa-minus-square ' : 'fa-plus-square ') + 'status__category-icon'}/> &nbsp;
                    <div>{title}</div>
                </div>
                {!isOpen &&
                <div
                    className={(mainStatus && mainStatus === 2) ? 'error-status' : 'success-status'}>{mainStatus === 2 ? 'Outage' : 'Operational'}</div>
                }
            </div>
            <Collapse isOpen={isOpen}>
                    <div className="status__subcategory">
                        {/*<div>{handleName(item.name)}</div>*/}
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <div>Status</div>
                            <div className={(item.status && item.status === 2) ? 'error-status' : 'success-status'}>{item.status === 2 ? 'Outage' : 'Operational'}</div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <div>Last Checked</div>
                            <div>{moment(item.updated_at).format('MM/DD/YYYY [at] h:mm A')}</div>
                        </div>
                    </div>
            </Collapse>
        </div>
    );
};

export default StatusItem;
